<template>
  <v-container
    id="entrega-leite-form"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="13"
        lg="7"
      >
        <!--FORMULARIO DE USUARIO NAO IDENTIFICADO-->
        <usuario-nao-identificado-form
          v-if="!usuarioIdentificado"
          :titulocard="$t('entrega-leite')"
        />
        <base-material-card
          v-else
          color="primary"
          icon="mdi-tanker-truck"
          :title="$t('entrega-leite')"
          :app-online="appOnline"
        >
          <v-skeleton-loader
            v-if="loading_laticinios"
            type="table-heading, table-tbody, table-tfoot"
          />
          <div
            v-else
          >
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent="pesquisar(laticinio.select.id, new Date(parseDate('01/' + dataPesquisa)).toISOString().substr(0, 10))"
            >
              <v-row>
                <v-col
                  cols="12"
                  lg="5"
                >
                  <v-select
                    :v-model="laticinio.select"
                    :items="laticinio.items"
                    item-text="nome"
                    item-value="id"
                    :success="true"
                    :disabled="disabledSelectLaticinio"
                    return-object
                    :label="laticinio.label"
                    @change="onChange($event)"
                  />
                </v-col>
                <v-col
                  cols="12"
                  lg="4"
                >
                  <v-select
                    v-if="temMaisDeUmProduto"
                    :v-model="produto.select"
                    :items="produto.items"
                    item-text="nome"
                    item-value="id"
                    :success="true"
                    :disabled="disableProduto"
                    return-object
                    :label="produto.label"
                    @change="onChangeProduto($event)"
                  />
                </v-col>
                <v-col
                  cols="12"
                  lg="3"
                >
                  <v-menu
                    ref="menuData"
                    v-model="menuData"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dataPesquisa"
                        v-mask="maskDataPesquisa"
                        :rules="dataPesquisaRules"
                        :disabled="disabledSelectDate"
                        :success="true"
                        label="Mês de Entrega"
                        style="max-width: 290px;"
                        @blur="date = parseDate('01/' + dataPesquisa)"
                        v-on="on"
                      >
                        <template
                          v-if="true"
                          v-slot:append-outer
                        >
                          <v-btn
                            :disabled="!valid"
                            class="mt-n2 mr-n2"
                            elevation="1"
                            fab
                            small
                            color="primary"
                            type="submit"
                          >
                            <v-icon>mdi-magnify</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      type="month"
                      no-title
                      @input="menuData = false"
                    />
                  </v-menu>
                </v-col>
              </v-row>
              <v-tabs
                v-model="selectedPropriedade"
                show-arrows
                align-with-title
                full-width
              >
                <v-tab
                  v-for="(item, index) in propriedade.items"
                  :key="index"
                  :value="item.id"
                  class="tab-text"
                  @change="onChangePropriedade(item)"
                >
                  {{ item.nomePropriedade }}
                </v-tab>
              </v-tabs>
              <v-skeleton-loader
                v-if="loading"
                height="250"
                type="table-tbody"
              />
              <div v-else>
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="primary--text">
                        Data
                      </th>
                      <th class="text-right primary--text">
                        Qtde (Litros)
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="carregouentrega">
                    <tr
                      v-for="(item, index) in listaEntregaLeite"
                      :key="index"
                      style="cursor: pointer;"
                    >
                      <td>{{ item.datarecepcao }}</td>
                      <td class="text-right">
                        {{ parseInteiro(item.qtde) }}
                      </td>
                      <td />
                      <td style="vertical-align: middle;">
                        <v-btn
                          v-if="item.analises.length > 0 && item.qtde > 0"
                          class="btn_analise"
                          min-width="0"
                          color="primary"
                          @click="carregaAnalises(item)"
                        >
                          Analíses
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <v-footer>
                  <v-spacer />
                  <div>Total de leite no período: <span class="font-weight-bold">{{ parseInteiro(laticinio.totalQtde) }} Litros</span></div>
                </v-footer>
              </div>
            </v-form>
          </div>
        </base-material-card>
      </v-col>
      <v-col
        v-if="false"
        cols="12"
        lg="5"
      >
        <base-material-card
          id="multiple-bar"
          color="primary"
          icon="mdi-poll-box"
          class="py-3"
          title="Comparativo Mensal"
        >
          <dashboard-grafico-barras
            :dados="dados_grafico"
            :titulo="'Entrega de Leite'"
            :subtitulo="'Compara os dois últimos anos de entrega'"
            :serie1="'2021'"
            :serie2="'2022'"
          />
        </base-material-card>
      </v-col>
      <analises-form
        :analises="analiseSelecionada"
        :empresadaanalise="empresaDaAnalise"
        :exibedialog="dialog"
        @update-dialog="updateDialog"
      />
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import RecepcaoProdutoService from '../../../services/recepcaoprodutoservice'
  import AnaliseService from '../../../services/analisesservice'
  import utils from '../../../services/utils'
  import AnalisesForm from './AnalisesForm.vue'

  export default {
    name: 'DashboardFormsEntregaLeiteForm',
    components: {
      AnalisesForm,
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
      DashboardGraficoBarras: () => import('../graficos/GraficoBarras'),
      UsuarioNaoIdentificadoForm: () => import('./UsuarioNaoIdentificadoForm'),
    },

    mixins: [utils],

    data: () => ({
      selectedPropriedade: null,
      analiseSelecionada: {
        listaAnalise: [],
        tanqueleite: [],
        analiseProdutor: [],
      },
      appOnline: navigator.onLine,
      usuarioIdentificado: true,
      valid: true,
      disabledSelectLaticinio: false,
      temMaisUmaPropriedade: false,
      disablePropriedade: true,
      disableProduto: true,
      disabledSelectDate: false,
      date: new Date().toISOString().substr(0, 10),
      dataPesquisa: '',
      maskDataPesquisa: '##/####',
      dataPesquisaRules: [
        v => /^\d{2}\/\d{4}$/.test(v),
      ],
      menuData: false,
      listaEntregaLeite: [
        {
          qtde: '',
          datarecepcao: '',
          analises: '',
        },
      ],
      listPropriedades: [],
      carregouentrega: false,
      laticinio: {
        label: 'Laticínio',
        select: { id: -1, nome: 'Nenhuma informação encontrada' },
        items: [
          { id: -1, nome: 'Nenhuma informação encontrada' },
        ],
        totalQtde: 0,
      },
      produto: {
        label: 'Produto',
        select: { id: 0, nome: 'Nenhuma informação encontrada' },
        items: [
          { id: 0, nome: 'Nenhuma informação encontrada' },
        ],
      },
      propriedade: {
        label: 'Propriedade',
        select: { id: -1, nomePropriedade: 'Nenhuma informação encontrada' },
        items: [
          { id: -1, nomePropriedade: 'Nenhuma informação encontrada' },
        ],
      },
      user: {
        username: '',
        roles: '["ROLE_PRODUTOR"]',
        password: '',
      },
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      loading: false,
      loading_laticinios: true,
      dados_grafico: {
        labels: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        series: [
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        ],
      },
      analises: [
        {
          analise: '',
        },
      ],
      produtor: '',
      produtorId: 0,
      produtorIds: [],
      empresaDaAnalise: {},
      temMaisDeUmProduto: false,
      dialog: false,
    }),
    watch: {
      date (val) {
        this.dataPesquisa = this.formatDate(val)
      },
    },

    mounted () {
      if (localStorage.chaveativacao && localStorage.chaveativacao !== 'undefined') {
        this.chaveativacao = localStorage.chaveativacao
        this.temMaisUmaPropriedade = false
        if (this.laticinio.select.id === -1) {
          this.disableProduto = true
          this.disablePropriedade = true

          this.temMaisUmaPropriedade = false
        }

        if (localStorage.getItem('usuarioIdentificado') && localStorage.getItem('usuarioIdentificado') === 'true') {
          this.usuarioIdentificado = true
          this.carregaForm()
        } else {
          this.usuarioIdentificado = false
        }
      } else {
        localStorage.clear()
        this.$router.push('/')
      }
    },

    methods: {
      async carregaForm () {
        this.loading_laticinios = true

        this.dataPesquisa = this.formatDate(this.date)

        await this.carregaLaticinios()

        if (this.propriedade.items.length > 0) {
          this.selectedPropriedade = this.propriedade.items[0].id
          this.onChangePropriedade(this.propriedade.items[0])
        }

        this.pesquisar(-1, this.date)
      },

      async carregaPropriedades (propriedades) {
        try {
          if (propriedades.length > 0) {
            this.listPropriedades = propriedades
            this.propriedade.items = propriedades

            if (propriedades.length === 1) {
              this.propriedade.select = propriedades[0]
              this.temMaisUmaPropriedade = false
              this.disablePropriedade = true
            }
            if (propriedades.length > 1) {
              this.selectedPropriedade = propriedades[0].id
              this.propriedade.select = propriedades[0]
            }
          }
        } catch (erro) {
          console.error('Erro ao carregar propriedades:', erro)
        }
      },

      pesquisar (idLaticinio, dataFiltro) {
        var mes = dataFiltro.substring(5, 7)
        var ano = dataFiltro.substring(0, 4)

        if (this.propriedade.select == null) {
          this.propriedade.select = this.propriedade.items[0]
        }

        if (idLaticinio === -1) {
          this.carregaLaticinios(mes, ano)
        } else if (idLaticinio === 0) {
          this.showSnackbar('warning', 3000, 'Selecione um laticínio antes de pesquisar.')
        } else if (this.propriedade.select === null) {
          this.showSnackbar('warning', 3000, 'Selecione uma propriedade antes de pesquisar.')
        } else {
          this.loading = true
          this.carregaEntregasDeLeite(idLaticinio, this.produto.select.id, this.propriedade.select.id, mes, ano)
          this.empresaDaAnalise = this.laticinio.items.find((item) => item.id === idLaticinio)
        }
      },

      async carregaLaticinios (mes, ano) {
        this.loading_laticinios = true
        await RecepcaoProdutoService.listarLaticinios(localStorage.chaveativacao).then(resposta => {
          this.verificaVersao(resposta.data.versao_vue)

          this.carregaPropriedades(resposta.data.propriedades)

          if (resposta.data.empresas.length > 0) {
            this.laticinio.items = resposta.data.empresas

            for (let i = 0; i < resposta.data.propriedades.length; i++) {
              this.produtorIds.push(resposta.data.propriedades[i])
            }

            if (resposta.data.empresas.length === 1) {
              this.empresaDaAnalise = resposta.data.empresas[0]
              this.carregaProdutos()

              this.laticinio.select = resposta.data.empresas[0]
              this.laticinio.label = resposta.data.empresas[0].nome
              this.disabledSelectLaticinio = true
              this.filtraProdutoPorLaticinio(this.laticinio.select.contrato_id, this.laticinio.select.nomeBD)
            }
            this.filtraPropriedadesPorLaticinio(this.laticinio.select.contrato_id, this.laticinio.select.nomeBD)
          }
          this.loading_laticinios = false
          this.disabledSelectDate = false
          this.appOnline = true
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            // this.$router.push('/')
          }
          this.loading_laticinios = false
        })
      },
      async filtraPropriedadesPorLaticinio (contratoId, nomeBD) {
        this.propriedade.items = await this.listPropriedades.filter(item => item.contrato_id === contratoId && item.nomeBD === nomeBD)

        this.temMaisUmaPropriedade = false
        this.disablePropriedade = true
        if (this.propriedade.items.length > 1) {
          this.propriedade.select = null
          this.temMaisUmaPropriedade = true
          this.disablePropriedade = false
        }
      },
      async filtraProdutoPorLaticinio (contratoId, nomeBD) {
        this.produto.items = await this.listPropriedades.filter(item => item.contrato_id === contratoId && item.nomeBD === nomeBD)
        this.temMaisDeUmProduto = false
        this.disableProduto = true
        if (this.produto.items.length > 1) {
          this.temMaisDeUmProduto = true
          this.disableProduto = false
        }
      },
      async carregaProdutos () {
        await RecepcaoProdutoService.listarProdutos(localStorage.chaveativacao, this.produtorIds).then(resposta => {
          if (resposta.data.produtos.length > 0) {
            this.produto.items = resposta.data.produtos
            if (resposta.data.produtos.length === 1) {
              this.temMaisDeUmProduto = false
            }
            this.produto.select = resposta.data.produtos[0]
            this.produto.label = resposta.data.produtos[0].nome
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            // this.$router.push('/')
          }
          this.loading_laticinios = false
        })
      },

      async carregaEntregasDeLeite (idLaticinio, produtoId, produtorId, mes, ano) {
        this.carregouentrega = true

        if (this.propriedade.items.length === 1) {
          this.filtraPropriedadesPorLaticinio(this.laticinio.select.contrato_id, this.laticinio.select.nomeBD)
          produtorId = this.propriedade.items[0].id
        }

        await RecepcaoProdutoService.listar(idLaticinio, produtoId, produtorId, mes, ano).then(resposta => {
          this.listaEntregaLeite = resposta.data.tabela
          this.calculaTotal()
          this.dados_grafico.series = resposta.data.dados_grafico
          if (this.listaEntregaLeite.length > 0) {
            this.salvaDadosOffline()
          }
          this.loading = false
          this.appOnline = true
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            // this.$router.push('/')
          }
          this.loading = false
        })
      },
      async carregaAnalises (item) {
        const produtorId = item.analises[0].idProdutor
        const dataRecepcao = item.datarecepcao
        var dataColeta = this.formatarData(dataRecepcao)
        await AnaliseService.listarAnalises(produtorId, dataColeta, this.laticinio.select.contrato_id).then(resposta => {
          if (resposta.data.success_request) {
            this.analiseSelecionada.listaAnalise = resposta.data.resultados
            this.analiseSelecionada.tanqueleite = resposta.data.tanques
            this.analiseSelecionada.analiseProdutor = resposta.data.analiseprodutor

            if (this.analiseSelecionada.listaAnalise.length > 0) {
              this.dialog = true
            } else {
              this.showSnackbar('alert', 3000, ' Não existem analises para essa coleta')
            }
          }
        }).catch(e => {
          console.error(e.message)
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            // this.carregaDadosOffline()
          } else {
            this.showSnackbar('error', 3000, e.message)
            this.dialog = false
          }
          this.loading = false
        })
      },
      formatarData (dataString) {
        var partesData = dataString.split('/')

        var data = new Date(partesData[2], partesData[1] - 1, partesData[0])

        var ano = data.getFullYear()
        var mes = ('0' + (data.getMonth() + 1)).slice(-2) // Adicionando zero à esquerda, se necessário
        var dia = ('0' + data.getDate()).slice(-2) // Adicionando zero à esquerda, se necessário

        return ano + '/' + mes + '/' + dia
      },
      async onChange (event) {
        this.laticinio.select = event
        this.listaEntregaLeite = null

        this.carregaProdutos(this.produtorId)
        this.filtraProdutoPorLaticinio(this.laticinio.select.contrato_id, this.laticinio.select.nomeBD)
        await this.filtraPropriedadesPorLaticinio(this.laticinio.select.contrato_id, this.laticinio.select.nomeBD)

        if (this.propriedade.items == null) {
          this.propriedade.items = this.listPropriedades[0]
        }
      },

      onChangeProduto (event) {
        this.produto.select = event
        this.produto.label = 'Produto'
        this.listaEntregaLeite = null
        // this.pesquisar(this.laticinio.select.id, new Date(this.parseDate('01/' + this.dataPesquisa)).toISOString().substr(0, 10))
      },
      onChangePropriedade (event) {
        this.propriedade.select = event
        this.propriedade.label = 'Propriedade'
        this.listaEntregaLeite = null

        this.pesquisar(this.laticinio.select.id, new Date(this.parseDate('01/' + this.dataPesquisa)).toISOString().substr(0, 10))
      },

      formatDate (date) {
        if (!date) return null

        const [year, month] = date.split('-')
        return `${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      calculaTotal () {
        this.laticinio.totalQtde = this.listaEntregaLeite.reduce((soma, item) => soma + item.qtde, 0)
      },

      salvaDadosOffline () {
        try {
          localStorage.laticinioSelecionadoEntregaLeite = this.laticinio.label
          localStorage.mesEntregaSelecionada = this.date
          const parsed = JSON.stringify(this.listaEntregaLeite)
          localStorage.setItem('listaEntregaLeite', parsed)
        } catch (e) {
        }
      },

      carregaDadosOffline () {
        this.appOnline = false
        this.laticinio.label = localStorage.laticinioSelecionadoEntregaLeite
        this.date = localStorage.mesEntregaSelecionada
        this.disabledSelectLaticinio = true
        this.disabledSelectDate = true
        if (localStorage.getItem('listaEntregaLeite')) {
          try {
            this.listaEntregaLeite = JSON.parse(localStorage.getItem('listaEntregaLeite'))
            this.calculaTotal()
          } catch (e) {
            localStorage.removeItem('listaEntregaLeite')
          }
        }
      },
      updateDialog (dialog) {
        this.dialog = dialog
      },
    },
  }
</script>
<style scoped>
  .highlight-row {
    background-color: rgb(38, 134, 18);
  }
  .linha-clicavel {
    background-color: #DCDCDC
  }
  .linha-normal {
    background-color: #FFFFFF
  }

.linha-clicavel:hover {
  background: rgb(38, 134, 18);
}
.btn_analise {
  text-transform: none;
  height: 5px !important;
  width: 15px !important;
  border-radius: 5px !important;
}
.tab-text {
  font-size: 12px;
  color: #4CAF50;
}
</style>
